export const CompensationTypes = {
    year: 'Yearly',
    hour: 'Hourly',
};
